/**
 * Deck statistics computation hook
 *
 * Thin memoized wrapper around `computeDeckStatistics`.
 * Types and computation live in `../lib/deckStatistics`.
 */
import { useMemo } from 'react';

import type { EnrichedDeckCard } from '@/types/deck';

import { computeDeckStatistics, DEFAULT_STATISTICS_ZONES, type DeckStatistics } from '../lib/deckStatistics';

/**
 * Compute comprehensive deck statistics from deck cards.
 *
 * @param cards - Array of deck cards with card data
 * @param zones - Optional zones to include (defaults to commander + companion + main)
 */
export default function useDeckStatistics(cards: EnrichedDeckCard[], zones: string[] = DEFAULT_STATISTICS_ZONES): DeckStatistics {
  return useMemo(() => computeDeckStatistics(cards, zones), [cards, zones]);
}
